<!-- Start of the message list component -->
<div class="h-full overflow-x-hidden py-4 backdrop-blur"
    [ngClass]="isEmbedded() ? '' : 'bg-background/95 supports-[backdrop-filter]:bg-background/60'">
    <div class="mx-auto max-w-full h-full overflow-x-hidden">
        <div class="flex flex-col gap-3 h-full overflow-x-hidden" [class.pr-2]="sidePanelService.isOpen()">

            <div class="h-full w-full overflow-y-auto overflow-x-hidden custom-scroll-viewport" #scrollContainer
                [class.is-scrolling]="isScrolling()" (scroll)="onScroll($event)">
                <div class="mx-auto max-w-[min(56rem,100%)] w-full px-[clamp(0rem,1.5vw,1.5rem)] flex flex-col gap-3">
                    @for(item of threadMessagesService.groupedMessages(); let index = $index; track item.id + '-' +
                    index) {
                    <div class="message-item" [style.animation-delay]="getMessageAnimationDelay(index)">
                        <ng-container [ngTemplateOutlet]="messageItemTpl"
                            [ngTemplateOutletContext]="{ item: item, index: index, depth: 0 }">
                        </ng-container>
                    </div>
                    }

                    <!-- Constructing / Summarizing Loading State -->
                    @if(isSummarizing()) {
                    <div class="mb-4 sm:mb-6">
                        <div class="flex flex-col">
                            <div class="flex gap-1.5 items-center">
                                <img [src]="getAssetUrl('bob_agent/bob_loading.gif')" alt="bob loading"
                                    class="w-[2.5rem] h-[2.5rem]" loading="lazy">
                                <span class="theme-text italic font-serif">
                                    Compacting our conversation so we can keep chatting<span
                                        class="summarizing-dots"><span>.</span><span>.</span><span>.</span></span>
                                </span>
                            </div>
                        </div>
                    </div>
                    }
                    @else if(threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.PENDING) {
                    <div class="mb-4 sm:mb-6">
                        <div class="flex gap-1.5 items-center">
                            <img [src]="getAssetUrl('bob_agent/bob_loading.gif')" alt="bob loading"
                                class="w-[2.5rem] h-[2.5rem]" loading="lazy">
                            <span class="text-sm theme-text italic font-serif inline-typewriter">You're in queue &mdash;
                                starting shortly.</span>
                        </div>
                    </div>
                    }
                    @else if(threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.IN_PROGRESS) {
                    @if(!hasAIResponseStarted()) {
                    <div class="mb-4 sm:mb-6">
                        <div class="flex flex-col">
                            <div class="flex gap-1.5 items-center">
                                <img [src]="getAssetUrl('bob_agent/bob_loading.gif')" alt="bob loading"
                                    class="w-[2.5rem] h-[2.5rem]" loading="lazy">
                            </div>
                        </div>
                    </div>
                    } @else {
                    <div class="mb-4 sm:mb-6">
                        <div class="flex items-center justify-start gap-1.5">
                            <app-blob-loader [width]="'1.5rem'" [height]="'1.5rem'"></app-blob-loader>
                            <div class="text-sm italic theme-text">
                                Constructing<span>{{ dots$ | async }}</span>
                            </div>
                        </div>
                    </div>
                    }
                    }

                    <app-thread-state-indicator [startTimer]="startTimer()" [pauseTimer]="pauseTimer()"
                        [canEdit]="canEdit()"
                        (approvePlan)="approvePlan.emit()" (rejectPlan)="rejectPlan.emit()"
                        (editPlan)="editPlan.emit($event)" (revisePlan)="revisePlan.emit($event)"
                        (timerExpired)="timerExpired.emit()" (continueAfterError)="continueAfterError.emit()"
                        (continueAfterPause)="continueAfterPause.emit()" (savePrompt)="saveAsPrompt.emit($event)"
                        (useExistingPrompt)="useExistingPrompt.emit($event)"
                        (generateNewPrompt)="generateNewPrompt.emit()">
                    </app-thread-state-indicator>
                </div>

            </div>

            @if(showScrollButton()) {
            <div class="absolute bottom-0 left-1/2 -translate-x-1/2 z-50">
                <app-button icon="pi pi-arrow-down" [iconSize]="'sm'" shape="circle" variant="outlined"
                    severity="contrast" (clicked)="scrollToBottom()">
                </app-button>
            </div>
            }
        </div>
    </div>
</div>

<!-- ============================================================
     Recursive item template
     Context: { item, index, depth }
     depth 0 = top-level, depth > 0 = nested inside task accordion
============================================================ -->
<ng-template #messageItemTpl let-item="item" let-index="index" let-depth="depth">
    @if (hasVisibleContent(item)) {
    <ng-container>
        @if (item.isToolGroup) {
        <ng-container *ngIf="asToolGroup(item) as toolGroup">

            <!-- ── TASK group ──────────────────────────────────── -->
            @if (toolGroup.isTask) {
            <div class="border border-gray-200 rounded-2xl w-full overflow-hidden"
                [ngClass]="isEmbedded() ? 'bg-transparent' : 'bg-white'">
                <!-- Header (clickable to toggle) -->
                <div class="flex items-center justify-between px-3 py-2.5 cursor-pointer select-none"
                    [ngClass]="{'border-b border-gray-200': !isTaskCardCollapsed(toolGroup.id)}"
                    (click)="toggleTaskCard(toolGroup.id)">
                    <!-- Left: icon + title -->
                    <div class="flex items-center gap-2">
                        <div class="bg-gray-100 rounded-md border border-gray-300 p-1">
                            <app-icon [type]="'bot'" [class]="'text-gray-600 [&>svg]:w-4 [&>svg]:h-4'" source="lucide"
                                size="default"></app-icon>
                        </div>
                        <span class="text-sm font-semibold text-neutral-900 truncate"
                            [ngClass]="{'shine-text': getToolGroupStatus(toolGroup) === TOOL_STATUS.LOADING}">
                            {{ getToolGroupTitle(toolGroup) }}
                        </span>
                    </div>
                    <!-- Right: progress + status + chevron -->
                    <div class="flex items-center gap-2 shrink-0">
                        <span class="text-xs text-gray-500 font-medium">
                            {{ getToolGroupProgress(toolGroup).completed }}/{{ getToolGroupProgress(toolGroup).total }}
                            done
                        </span>
                        @if (getToolGroupStatus(toolGroup) === TOOL_STATUS.SUCCESS) {
                        <span class="text-xs text-green-600 font-medium hidden sm:inline">All tools completed</span>
                        } @else if (getToolGroupStatus(toolGroup) === TOOL_STATUS.ERROR) {
                        <span class="text-xs text-amber-600 font-medium hidden sm:inline">Failed</span>
                        } @else {
                        <span class="text-xs text-blue-600 font-medium hidden sm:inline">In progress</span>
                        }
                        <app-icon [type]="getToolGroupStatusIcon(toolGroup)"
                            [class]="getToolGroupStatusIconClass(toolGroup)" source="lucide" size="sm"></app-icon>
                        <app-icon type="chevron-down" source="lucide" size="default"
                            class="text-gray-400 transition-transform duration-200"
                            [ngClass]="{'rotate-180': !isTaskCardCollapsed(toolGroup.id)}"></app-icon>
                    </div>
                </div>
                <!-- Content (hidden when collapsed) -->
                @if (!isTaskCardCollapsed(toolGroup.id)) {
                <div class="max-h-56 overflow-y-auto p-3">
                    @if (isTaskCompleted(toolGroup) && toolGroup.taskResult) {
                    <!-- Task done: final output -->
                    <pre
                        class="text-xs text-gray-600 font-mono whitespace-pre-wrap break-all">{{ toolGroup.taskResult.content }}</pre>
                    } @else {
                    <!-- Task running: nested subagent content -->
                    <div class="flex flex-col gap-1.5">
                        @for (nestedItem of toolGroup.nestedGroupedMessages; let nestedIndex = $index; track
                        nestedItem.id + '-' + nestedIndex) {
                        <ng-container [ngTemplateOutlet]="messageItemTpl"
                            [ngTemplateOutletContext]="{ item: nestedItem, index: nestedIndex, depth: depth + 1 }">
                        </ng-container>
                        }
                        @if (isTaskSummarizing(toolGroup)) {
                        <div class="flex gap-1.5 items-center py-1.5">
                            <img [src]="getAssetUrl('bob_agent/bob_loading.gif')" alt="bob loading"
                                class="w-[1.5rem] h-[1.5rem]" loading="lazy">
                            <span class="text-sm text-gray-500 italic font-serif">
                                Compacting our conversation so we can keep chatting<span
                                    class="summarizing-dots"><span>.</span><span>.</span><span>.</span></span>
                            </span>
                        </div>
                        }
                    </div>
                    }
                </div>
                }
            </div>
            }

            <!-- ── Regular tool group ──────────────────────────── -->
            @else {
            <p-accordion [multiple]="false"
                [styleClass]="'w-full custom-accordion ' + (depth > 0 ? 'bg-white border border-gray-100' : (isEmbedded() ? 'bg-transparent custom-accordion-embedded' : 'bg-gray-50'))"
                [attr.data-status]="getToolGroupStatus(toolGroup)"
                [value]="getAccordionState(index, toolGroup) === 0 ? '0' : undefined"
                (onOpen)="activeAccordionIndexes[index]=0" (onClose)="activeAccordionIndexes[index]=-1">
                <p-accordion-panel value="0">
                    <p-accordion-header
                        [ngClass]="{'inactive ': getAccordionState(index, toolGroup) !== 0, 'active': getAccordionState(index, toolGroup) === 0}">
                        <div class="flex items-center gap-3 w-full py-1.5">
                            <div class="flex items-center gap-1.5">
                                <div class="flex -space-x-2">
                                    @for (toolMessage of getToolMessages(toolGroup).slice(0, 3); track toolMessage.id) {
                                    <div
                                        class="bg-gray-50 rounded-md border border-gray-300 px-1 py-3 h-4 min-w-4 relative z-0 shrink-0 flex items-center justify-center">
                                        <app-icon [type]="getArtifactToolIcon(toolMessage).icon"
                                            [class]="'text-gray-600'"
                                            [source]="getArtifactToolIcon(toolMessage).iconSource ?? 'lucide'"
                                            [size]="'sm'"></app-icon>
                                    </div>
                                    }
                                    @if (getToolMessages(toolGroup).length > 3) {
                                    <div
                                        class="bg-gray-50 rounded-md border border-gray-300 p-1 flex items-center justify-center min-w-[24px] relative z-10">
                                        <span class="text-[10px] text-gray-600 font-medium">+{{
                                            getToolMessages(toolGroup).length - 3 }}</span>
                                    </div>
                                    }
                                </div>
                                <div class="light">
                                    <div class="wrapper">
                                        <span class="text-sm font-medium text-neutral-900 truncate"
                                            [ngClass]="{'shine-text': getToolGroupStatus(toolGroup) === TOOL_STATUS.LOADING}">
                                            {{ getToolGroupTitle(toolGroup) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <!-- Status right side -->
                            <div class="flex items-center gap-3 ml-auto mr-1">
                                <span class="text-xs text-gray-500 font-medium">
                                    {{ getToolGroupProgress(toolGroup).completed }}/{{
                                    getToolGroupProgress(toolGroup).total }} done
                                </span>
                                <div class="flex items-center gap-1.5">
                                    @if (getToolGroupStatus(toolGroup) === TOOL_STATUS.SUCCESS) {
                                    <span class="text-xs text-green-600 font-medium hidden sm:inline">All tools
                                        completed</span>
                                    } @else if (getToolGroupStatus(toolGroup) === TOOL_STATUS.ERROR) {
                                    <span class="text-xs text-amber-600 font-medium hidden sm:inline">Failed</span>
                                    } @else {
                                    <span class="text-xs text-blue-600 font-medium hidden sm:inline">In
                                        progress</span>
                                    }
                                    <app-icon [type]="getToolGroupStatusIcon(toolGroup)"
                                        [class]="getToolGroupStatusIconClass(toolGroup)" source="lucide"
                                        size="xs"></app-icon>
                                </div>
                            </div>
                        </div>
                    </p-accordion-header>
                    <p-accordion-content>
                        <div class="flex flex-col bg-transparent">
                            @for (toolMessage of toolGroup.messages; track toolMessage.id) {
                            @if (toolMessage.type === 'ai') {
                            @if (toolMessage.content) {
                            <div class="py-1.5 px-2 text-xs text-gray-500 italic whitespace-pre-wrap font-mono">
                                {{ toolMessage.content }}
                            </div>
                            }
                            } @else if (toolMessage.type === 'tool') {
                            @if (isPrivateToolMessage(toolMessage)) {
                            <div class="flex items-center gap-1.5 py-1.5 px-2 my-0.5">
                                <app-icon [type]="getArtifactToolIcon(toolMessage).icon"
                                    [source]="getArtifactToolIcon(toolMessage).iconSource ?? 'lucide'"
                                    size="sm"></app-icon>
                                <span class="text-xs font-medium text-gray-700 truncate min-w-0"
                                    [ngClass]="{'animate-pulse text-gray-500': getArtifactToolStatus(toolMessage) === TOOL_STATUS.LOADING}">
                                    {{ getPrivateToolLabel(toolMessage) }}
                                </span>
                                <div class="ml-auto flex items-center shrink-0">
                                    <app-icon [type]="getArtifactStatusIcon(toolMessage)"
                                        [class]="getArtifactStatusIconClass(toolMessage) + ' [&>svg]:w-3.5 [&>svg]:h-3.5'"
                                        source="lucide" size="xs"></app-icon>
                                </div>
                            </div>
                            } @else {
                            <div class="flex flex-col my-0.5"
                                [ngClass]="{'border border-gray-200 rounded-lg p-1': isToolCallStreaming(toolMessage), 'bg-gray-50/50': isToolCallStreaming(toolMessage) && !isEmbedded()}">
                                <div class="flex items-center gap-1.5 py-1.5 px-2 my-0.5 rounded cursor-pointer hover:bg-gray-100 transition-colors"
                                    (click)="onArtifactClick(toolMessage)">
                                    <app-icon [type]="getArtifactToolIcon(toolMessage).icon"
                                        [class]="'text-gray-600 [&>svg]:w-3.5 [&>svg]:h-3.5'"
                                        [source]="getArtifactToolIcon(toolMessage).iconSource ?? 'lucide'"
                                        size="sm"></app-icon>
                                    <span class="text-xs font-medium text-gray-700 truncate min-w-0"
                                        [ngClass]="{'animate-pulse text-gray-500': getArtifactToolStatus(toolMessage) === TOOL_STATUS.LOADING}">
                                        @if (isToolCallStreaming(toolMessage)) {
                                        {{ getStreamingToolTitle(toolMessage) }}
                                        } @else {
                                        {{ getArtifactFormattedToolName(toolMessage) }}
                                        }
                                    </span>
                                    <div class="ml-auto flex items-center shrink-0">
                                        <app-icon [type]="getArtifactStatusIcon(toolMessage)"
                                            [class]="getArtifactStatusIconClass(toolMessage) + ' [&>svg]:w-3.5 [&>svg]:h-3.5'"
                                            source="lucide" size="xs"></app-icon>
                                    </div>
                                </div>
                                @if (isToolCallStreaming(toolMessage) && getStreamingArgs(toolMessage)) {
                                <pre
                                    class="streaming-args-container mx-1 mb-1 px-3 py-2 text-xs text-gray-600 bg-white/80 rounded-md overflow-x-auto max-h-40 overflow-y-auto font-mono whitespace-pre-wrap break-all border border-gray-200">{{ getStreamingArgs(toolMessage) }}</pre>
                                }
                            </div>
                            }
                            }
                            }
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>
            <!-- Images -->
            @for (imageUrl of toolGroup.imageUrls; track imageUrl) {
            <div class="w-96 h-auto max-h-[32rem] overflow-hidden rounded-lg cursor-pointer"
                (click)="openImagePreview.emit(imageUrl)">
                <img [src]="imageUrl" alt="image" class="object-contain w-full h-full" loading="lazy">
            </div>
            }
            }

        </ng-container>
        } @else {
        <ng-container *ngIf="asMessage(item) as message">
            <!-- HUMAN MESSAGE -->
            @if(message.type === MESSAGE_TYPE.HUMAN) {
            @if(isSummarizationMessage(message)) {
            <div class="flex items-center gap-2 py-1.5">
                <app-icon [type]="icons.AI_CHAT_STARS" source="svg" size="sm"></app-icon>
                <span class="text-sm text-gray-500 italic">Context summarized</span>
            </div>
            } @else {
            <app-human-message [message]="message" [isOwner]="isOwner()" [canEdit]="isOwner()"
                (edit)="onEditMessage($event)" (saveEnhancement)="saveEnhancement.emit($event)">
            </app-human-message>
            }
            }
            <!-- AI / TOOL / SYSTEM MESSAGE -->
            @else if(message.type === MESSAGE_TYPE.AI || showArtifact(message)) {
            <!-- Bob Avatar (only at top level) -->
            @if(depth === 0 && shouldShowBobAvatar(index, message.type)) {
            <div class="flex gap-1.5 items-center">
                @if(showLoadingBob(index, message.type)) {
                <img [src]="getAssetUrl('bob_agent/bob_loading.gif')" alt="bob loading" class="w-[2.5rem] h-[2.5rem]"
                    loading="lazy">
                } @else {
                <img [src]="getAssetUrl('bob_agent/bob_thread.svg')" alt="bob" class="w-[2.5rem] h-[2.5rem]"
                    loading="lazy">
                }
                <span class="theme-text">Bob</span>
            </div>
            }

            <!-- AI Text Message -->
            @if(message.type === 'ai' && message.content && message.content.trim()) {
            <app-ai-message [message]="message" [isOwner]="isOwner()" [hasFeedback]="hasFeedback(message.id)"
                (feedback)="onFeedback($event, message.id)">
            </app-ai-message>
            }
            <!-- Images -->
            <!-- Full Canvas Card -->
            @else if(getCanvasDetails(message).canvasContent) {
            @if(getCanvasDetails(message).isLatestVersion){
            <div class="border border-gray-200 rounded-2xl bg-white">
                <div class="flex items-center justify-between mb-3 border-b border-gray-200 p-3">
                    <div class="flex items-center">
                        <span class="font-semibold truncate text-sm max-w-[600px] lg:max-w-[400px]">{{
                            getCanvasDetails(message).canvasName
                            }}</span>
                    </div>
                    <div class="flex items-center gap-3">
                        <div class="cursor-pointer" (click)="copyCanvas(message)" pTooltip="Copy"
                            tooltipPosition="bottom">
                            <app-icon [type]="getCopyIcon(message.id)" [class]="'h-4 w-4 text-zinc-900'"
                                [source]="'lucide'" [size]="'default'"></app-icon>
                        </div>
                        @if(isOwner()) {
                        <div class="cursor-pointer"
                            (click)="openCanvasPanel.emit({message: message, isEditable: isOwner()})" pTooltip="Edit"
                            tooltipPosition="bottom">
                            <app-icon [type]="'pencil'" [class]="'h-4 w-4 text-zinc-900'" [source]="'lucide'"
                                [size]="'default'"></app-icon>
                        </div>
                        }
                        <div class="cursor-pointer" (click)="downloadCanvas.emit(message)" pTooltip="Download"
                            tooltipPosition="bottom">
                            <app-icon [type]="'download'" [class]="'h-4 w-4 text-zinc-900'" [source]="'lucide'"
                                [size]="'default'"></app-icon>
                        </div>
                    </div>
                </div>
                <div class="p-3">
                    <app-canvas [message]="message" [isEditable]="false"
                        [threadMetadataId]="threadMetadataId()"></app-canvas>
                </div>
            </div>
            }
            <!-- Canvas Link (Edited/Older) -->
            @else{
            <div class="group">
                <div class="flex items-center gap-1.5 text-sm text-gray-600 cursor-pointer group-hover:text-black"
                    (click)="openCanvasPanel.emit({message: message, isEditable: false})">
                    <app-icon [type]="'file-text'" source="lucide" size="sm"></app-icon>
                    <div>{{getCanvasDetails(message).isFirstVersion ? '' : 'Edited '}}
                        {{getCanvasDetails(message).canvasName}}</div>
                </div>
            </div>
            }
            }
            }
        </ng-container>
        }
    </ng-container>
    }
</ng-template>
